import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
      ]
    },
    clientName: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
      ]
    },
    addressline1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    postal: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    StartTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteAddress: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteCity: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteState: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SitePostal: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    Website: {
      validations: []
    },   
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'Email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Organization Name:',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Event Details:',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'EventDate'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:*',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Host Street Address:*',
            mapping: 'addressline1'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Host City:*',
            mapping: 'city'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Host State:*',
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Host Zip Code:*',
            mapping: 'postal'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:*',
            options: [
              { label: 'Reunion', value: 'Reunion' },
              { label: 'Birthday', value: 'Birthday'},
              { label: 'Graduation', value: 'Graduation'},
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Rehersal Dinner', value: 'Rehersal Dinner'},
              { label: 'Engagement Party', value: 'Engagement Party'},
              { label: 'Bar Mitzvah', value: 'Bar Mitzvah'},
              { label: 'Bat Mitzvah', value: 'Bat Mitzvah'},
              { label: 'Anniversary', value: 'Anniversary'},
              { label: 'Fundraiser', value: 'Fundraiser'},
              { label: 'Office Event', value: 'Office Event'},
              { label: 'Other', value: 'Other'},
            ],
            mapping: 'Theme'
          },
          {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Anticipated Gelato Service Start Time:*',
                options: [
                  { label: '6:00 AM', value: '06:00:00' },
                  { label: '6:30 AM', value: '06:30:00' },
                  { label: '7:00 AM', value: '07:00:00' },
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' },
                  { label: '10:30 PM', value: '22:30:00' },
                  { label: '11:00 PM', value: '23:00:00' },
                  { label: '11:30 PM', value: '23:30:00' },
                  { label: '12:00 AM', value: '00:00:00' },
                  { label: '12:30 AM', value: '00:30:00' },
                  { label: '1:00 AM', value: '01:00:00' },
                  { label: '1:30 AM', value: '01:30:00' },
                  { label: '2:00 AM', value: '02:00:00' },
                  { label: '2:30 AM', value: '02:30:00' },
                  { label: '3:00 AM', value: '03:00:00' },
                  { label: '3:30 AM', value: '03:30:00' },
                  { label: '4:00 AM', value: '04:00:00' },
                  { label: '4:30 AM', value: '04:30:00' },
                  { label: '5:00 AM', value: '05:00:00' },
                  { label: '5:30 AM', value: '05:30:00' }
                ],
                mapping: 'StartTime'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Event Location Name:*',
                mapping: 'SiteName'
              },
              {
                type: 'text',
                size: 'Medium',
                label: 'Event Location Street Address:*',
                mapping: 'SiteAddress'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Event Location City:*',
                mapping: 'SiteCity'
              },
              {
                type: 'text',
                size: 'Medium',
                label: 'Event Location State:*',
                mapping: 'SiteState'
              },
              {
                type: 'text',
                size: 'Medium',
                label: 'Event Location Zip:*',
                mapping: 'SitePostal'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'How did you hear about us?*',
                options: [
                  { label: 'Websearch', value: 'Websearch' },
                  { label: 'Referral', value: 'Referral' },
                  { label: 'Event Planner', value: 'Event Planner' },
                  { label: 'Our Sales Team', value: 'Our Sales Team' },
                  { label: 'Email Received', value: 'Email Received' },
                  { label: 'Mailing Received', value: 'Mailing Received' },
                  { label: 'Other', value: 'Other' },
                ],
                mapping: 'Reference'
              }
            ]
          },
          {
            fields: [
              {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Culinary Team - Gemma Gelato - Contact Form',
    formId: '1888',
    clientKey: 'DE6D97D3-AAAD-47CF-8807-F687374AFD6A',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
